module.exports = __webpack_public_path__ + "img/share.3327019d.png";